import DealershipPage from './dealership.container';

export default DealershipPage;